<template>
  <label class="switch" :class="className">
    <span class="one" :class="{ active: active }">{{ textTrue }}</span>
    <input type="checkbox" :checked="!active" @change="switchHandler()" />
    <span class="slider"></span>
    <span class="two" :class="{ active: !active }">{{ textFalse }}</span>
  </label>
</template>

<script>
  export default {
    name: 'SwitchComponent',
    props: {
      checked: {
        type: Boolean,
        default: true,
      },
      className: {
        type: String,
        default: '',
      },
      textTrue: {
        type: String,
        default: 'Товары',
      },
      textFalse: {
        type: String,
        default: 'Услуги',
      },
    },
    data() {
      return {
        active: this.checked,
      };
    },
    methods: {
      switchHandler() {
        this.active = !this.active;
        this.$emit('switchHandler', this.active);
      },
    },
  };
</script>

<style scoped lang="scss">
  .switch {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    position: relative;
  }

  .switch.big {
    margin-left: 170px;
    .one {
      left: -170px;
    }
    .two {
      right: -185px;
    }
  }

  @media (max-width: 767px) {
    .switch {
      .one,
      .two {
        font-size: 12px;
      }
    }
  }

  .one,
  .two {
    font-family: 'Fira Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: $dark-grey-1;
  }
  .one.active {
    // font-family: Roboto, Arial, sans-serif;
    // background-color: #2aa5a0;
    font-style: normal;
    // font-weight: bold;
    font-size: 14px;
    color: #0093ba;
    // line-height: 14px;
    // background: linear-gradient(270deg, #00b2aa 0%, #0078c8 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .two.active {
    // font-family: Roboto, Arial, sans-serif;
    // background-color: #2aa5a0;
    // font-style: normal;
    // font-weight: bold;
    font-size: 14px;
    color: #0093ba;
    // line-height: 14px;
    // background: linear-gradient(270deg, #00b2aa 0%, #0078c8 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: relative;
    width: 48px;
    height: 26px;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(270deg, #00b2aa 0%, #0078c8 100%);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border: 1px solid #00b2aa;
    border-radius: 24px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    top: 1.5px;
    left: 2px;
    bottom: 4px;
    background: #ffffff;
    border-radius: 24px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: white;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px white;
  }

  input:checked + .slider:before {
    transform: translateX(23px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
